import {Trans, useTranslation} from "react-i18next";

const LegalTexts = () => {

    const {t} = useTranslation();

    return (
        <>
            <div>
                <p>
                    <Trans t={t}>{t('additional_text_1')}</Trans>
                </p>
            </div>
        </>
    )
}

export default LegalTexts;
